import isFilledUp from './fields/isFilledUp'
import isMobileNumber from './fields/isMobileNumber'

const validateMobileNumber = (name, mobileNumber) => {
  if (!isFilledUp(mobileNumber)) {
    return { [name]: 'Mobile number is required' }
  }
  if (!isMobileNumber(mobileNumber)) {
    return { [name]: 'Invalid mobile number' }
  }
  return {}
}

// const validatePassword = (name, password) => {
//   if (!isFilledUp(password)) {
//     return { [name]: 'Password is required' }
//   }
//   return {}
// }

const validate = values => {
  if (typeof values !== 'object' || values === null) {
    throw new Error(
      'Invalid argument. Validator functions only expect a non-null object.',
    )
  }
  const {
    username,
    // , password
  } = values

  return {
    ...validateMobileNumber('username', username),
    // ...validatePassword('password', password),
  }
}

export default validate
